const services = [
  {
    step: "01",
    title: "Réglage oscillo-battant",
    desc: "Votre fenêtre ne bascule plus correctement ? Nous réglons le mécanisme pour un fonctionnement fluide.",
  },
  {
    step: "02",
    title: "Oscillo-battant bloqué",
    desc: "Le mécanisme est coincé en position ouverture ? Intervention rapide pour débloquer et réparer.",
  },
  {
    step: "03",
    title: "Crémone cassée",
    desc: "Crémone fendue ou usée ? Remplacement de la pièce par une neuve, adaptée à toutes les marques.",
  },
  {
    step: "04",
    title: "Poignée bloquée",
    desc: "Poignée qui tourne dans le vide ou ne tourne plus ? Réparation ou remplacement sur place.",
  },
  {
    step: "05",
    title: "Gond & paumelle",
    desc: "Fenêtre qui frotte ou s'ouvre mal ? Réglage ou remplacement des gonds et paumelles.",
  },
  {
    step: "06",
    title: "Fenêtre qui ferme mal",
    desc: "Infiltration d'air, fenêtre mal calfeutrée ? Diagnostic complet et réparation du mécanisme.",
  },
];

export default function Services() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full border border-plum text-plum text-sm font-medium mb-4">
            Nos prestations
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-4">
            Toutes les réparations de fenêtre
          </h2>
          <p className="text-plum-dark text-base md:text-lg max-w-2xl mx-auto">
            Nos techniciens interviennent chez vous pour réparer le mécanisme, pas remplacer la fenêtre.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => (
            <div
              key={s.step}
              className="group bg-white border border-rose-200 rounded-2xl p-6 md:p-8 hover:bg-plum transition-colors duration-300 cursor-default"
            >
              <div className="w-14 h-14 rounded-2xl bg-rose-50 flex items-center justify-center mb-5 group-hover:bg-white/10 transition-colors">
                <span className="font-serif text-xl font-bold text-plum group-hover:text-white transition-colors">
                  {s.step}
                </span>
              </div>
              <h3 className="text-lg font-bold text-plum mb-3 group-hover:text-white transition-colors">
                {s.title}
              </h3>
              <p className="text-sm text-plum-dark leading-relaxed group-hover:text-white/80 transition-colors">
                {s.desc}
              </p>
              <div className="mt-4 flex items-center gap-1 text-coral group-hover:text-white transition-colors">
                <span className="text-sm font-medium">En savoir plus</span>
                <i className="ri-arrow-right-line text-sm" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}